import React, { Component } from "react";

import Error from "./Error";

class ErrorBoundry extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		console.log(error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<React.Fragment>
					<Error />
				</React.Fragment>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundry;
